import { EntityRefUtil, FormDTO, GetRepairFormsRequestDTO } from '@gearbelt/global';
import { AccessorKeyColumnDef, createColumnHelper } from '@tanstack/react-table';
import { formatDistanceToNow } from 'date-fns';

import { Checkbox } from '@/components/ui/checkbox';

const columnHelper = createColumnHelper<FormDTO>();

export const columns = [
  columnHelper.display({
    id: 'select',
    header: ({ table }) => (
      <div className="flex w-full justify-center">
        <label className="-m-2 p-2">
          <Checkbox checked={table.getIsAllPageRowsSelected()} onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)} aria-label="Select all" />
        </label>
      </div>
    ),
    cell: ({ row }) => (
      <div className="flex w-full justify-center">
        <label className="-m-2 p-2" onClick={(e) => e.stopPropagation()}>
          <Checkbox checked={row.getIsSelected()} onCheckedChange={(value) => row.toggleSelected(!!value)} aria-label="Select row" />
        </label>
      </div>
    ),
    meta: {
      cellClassName: 'w-[40px] min-w-[40px] max-w-[40px]',
    },
    enableSorting: false,
    enableHiding: false,
  }),
  columnHelper.accessor('name', {
    header: 'Name',
    cell: ({ row }) => (
      <div className="flex w-full justify-between">
        <span>{row.original.name}</span>
      </div>
    ),
    meta: {
      filterType: 'text',
    },
    enableColumnFilter: true,
  }),
  columnHelper.accessor('number', {
    header: 'Form ID',
    cell: ({ row }) => EntityRefUtil.createFormRef(row.original.number),
    meta: {
      filterType: 'text',
    },
    enableColumnFilter: true,
  }),
  columnHelper.accessor('updatedAt', {
    header: 'Updated At',
    cell: ({ getValue }) => formatDistanceToNow(new Date(getValue()), { addSuffix: true }),
  }),
  columnHelper.accessor('revision', {
    header: 'Version',
    meta: {
      filterType: 'text',
    },
    enableColumnFilter: true,
  }),
  columnHelper.accessor('createdBy', {
    header: 'Created by',
    cell: ({ row }) => EntityRefUtil.createUserFullNameRef(row.original.createdBy, '-'),
    enableSorting: false,
  }),
] as AccessorKeyColumnDef<FormDTO>[];

export const FILTER_FIELD_MAP: Record<string, keyof NonNullable<NonNullable<GetRepairFormsRequestDTO['filters']>['fields']>> = {
  name: 'name',
  number: 'number',
  updatedAt: 'updatedAt',
  revision: 'revision',
};
